module.exports = __webpack_public_path__ + "img/ez.f7cc160e.png";